<template>
    <div class="float-left mr-1">
        <span class="text-primary">
            <i
                class="fa fa-pencil-square-o fa-lg icon-button"
                title="Atualizar rateio"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <rateio-requisicao-form
            titulo="Atualizar Rateio"
            operacao="A"
            :requisicao="requisicao"
            :comprometimento="comprometimento"
            :erros="erros"
            :mostrarModal="mostrarModal"
            @fecharModal="fecharModal()"
            @atualizarRateio="$emit('atualizarRateio', $event)"
        ></rateio-requisicao-form>
    </div>
</template>

<script>
import RateioRequisicaoForm from './RateioRequisicaoForm'

export default {
    props: {
        requisicao: {
            type: Object
        },

        erros: {
            type: Array,
            default: () => []
        },

        comprometimento: {
            type: Object
        }
    },

    components: {
        RateioRequisicaoForm
    },

    data() {
        return {
            mostrarModal: false
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
        },

        abrirModal() {
            this.mostrarModal = true
        }
    },

    computed: {},

    created() {}
}
</script>
